<template>
  <div
    :class="[
      'sidebar-area position-fixed start-0 top-0 bg-black h-100vh transition',
      { active: stateStoreInstance.open },
    ]"
    id="sidebar-area"
  >
    <div class="logo position-absolute start-0 end-0 top-0 bg-black">
      <router-link
        to="/"
        class="d-flex align-items-center text-white text-decoration-none"
      >
        <img
          :src="settingsStore.logo || require('../../assets/images/logo.png')"
          alt="logo-icon"
          style="width: 80%; max-height: 44px; object-fit: fill;"
        />
      </router-link>
      <div class="border-bottom"></div>
      <button
        class="sidebar-burger-menu position-absolute lh-1 bg-transparent p-0 border-0"
        @click="stateStoreInstance.onChange"
      >
        <i class="ph-duotone ph-caret-double-right"></i>
      </button>
    </div>
    <div class="sidebar-menu">
      <ul
        class="sidebar-navbar-nav ps-0 mb-0 list-unstyled accordion"
        id="sidebarNavAccordion"
      >
        <li class="sidebar-nav-item" v-if="auth.can('HOME_PAGE')">
          <router-link to="/" class="sidebar-nav-link d-block">
            <i class="flaticon-more-1"></i>
            <span class="title">Dashboard</span>
          </router-link>
        </li>
        <li
          v-if="auth.can('PARCELS')"
          class="sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
        >
          <a
            href="#"
            class="accordion-button collapsed rounded-0 shadow-none bg-transparent d-block"
            data-bs-toggle="collapse"
            data-bs-target="#sidebarCollapseColis"
            aria-expanded="false"
            aria-controls="sidebarCollapseColis"
          >
            <i class="flaticon-sterile-box"></i>
            <span class="title">Colis</span>
          </a>
          <div
            id="sidebarCollapseColis"
            class="accordion-collapse collapse"
            data-bs-parent="#sidebarNavAccordion"
          >
            <div class="accordion-body">
              <ul class="sidebar-sub-menu ps-0 mb-0 list-unstyled">
                <li class="sidebar-sub-menu-item" v-if="auth.can('PARCELS')">
                  <router-link to="/colis-list" class="sidebar-sub-menu-link">
                    Liste des colis
                  </router-link>
                </li>
                <li class="sidebar-sub-menu-item" v-if="auth.can('PARCELS')">
                  <router-link
                    to="/new-colis-list"
                    class="sidebar-sub-menu-link"
                  >
                    Nouveaux colis
                  </router-link>
                </li>
                <li class="sidebar-sub-menu-item" v-if="auth.can('PARCELS')">
                  <router-link to="/add-colis" class="sidebar-sub-menu-link">
                    Nouveau Colis
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
        </li>

        <li
          v-if="auth.can('STOCK')"
          class="sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
        >
          <a
            href="#"
            class="accordion-button collapsed rounded-0 shadow-none bg-transparent d-block"
            data-bs-toggle="collapse"
            data-bs-target="#sidebarCollapseStock"
            aria-expanded="false"
            aria-controls="sidebarCollapseStock"
          >
            <i class="flaticon-sterile-box"></i>
            <span class="title">Inventaire</span>
          </a>
          <div
            id="sidebarCollapseStock"
            class="accordion-collapse collapse"
            data-bs-parent="#sidebarNavAccordion"
          >
            <div class="accordion-body">
              <ul class="sidebar-sub-menu ps-0 mb-0 list-unstyled">
                <li class="sidebar-sub-menu-item" v-if="auth.can('STOCK')">
                  <router-link
                    to="/products-list"
                    class="sidebar-sub-menu-link"
                  >
                    Liste des produits
                  </router-link>
                </li>
                <li
                  class="sidebar-sub-menu-item"
                  v-if="auth.can('STOCK') && auth.can('PARCELS')"
                >
                  <router-link
                    to="/colis-stock-list"
                    class="sidebar-sub-menu-link"
                  >
                    Colis de stock
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
        </li>

        <li
          v-if="auth.can('BL') || auth.can('BL_S')"
          class="sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
        >
          <a
            href="#"
            class="accordion-button collapsed rounded-0 shadow-none bg-transparent d-block"
            data-bs-toggle="collapse"
            data-bs-target="#sidebarCollapseBl"
            aria-expanded="false"
            aria-controls="sidebarCollapseBl"
          >
            <i class="flaticon-document"></i>
            <span class="title">Bons de livraison</span>
          </a>
          <div
            id="sidebarCollapseBl"
            class="accordion-collapse collapse"
            data-bs-parent="#sidebarNavAccordion"
          >
            <div class="accordion-body">
              <ul class="sidebar-sub-menu ps-0 mb-0 list-unstyled">
                <li class="sidebar-sub-menu-item" v-if="auth.can('BL')">
                  <router-link
                    to="/delivery-notes"
                    class="sidebar-sub-menu-link"
                  >
                    Bons de livraison
                  </router-link>
                </li>
                <li class="sidebar-sub-menu-item" v-if="auth.can('BL_S')">
                  <router-link
                    to="/delivery-stock-notes"
                    class="sidebar-sub-menu-link"
                  >
                    Bons de livraison stock
                  </router-link>
                </li>
                <!-- <li class="sidebar-sub-menu-item" v-if="auth.can('BL_EXT')">
                  <router-link to="/delivery-extern-notes" class="sidebar-sub-menu-link">
                    Bons de livraison externes
                  </router-link>
                </li> -->
              </ul>
            </div>
          </div>
        </li>

        <li class="sidebar-nav-item" v-if="auth.can('RECEPTION')">
          <router-link to="/reception-notes" class="sidebar-nav-link d-block">
            <i class="flaticon-draft"></i>
            <span class="title">Réception Colis</span>
          </router-link>
        </li>

        <li class="sidebar-nav-item" v-if="auth.can('BE')">
          <router-link to="/sent-notes" class="sidebar-nav-link d-block">
            <i class="flaticon-telegram"></i>
            <span class="title">Bons d'envoi</span>
          </router-link>
        </li>

        <li class="sidebar-nav-item" v-if="auth.can('BDIS')">
          <router-link
            to="/distribution-notes"
            class="sidebar-nav-link d-block"
          >
            <i class="flaticon-cube-3d"></i>
            <span class="title">Bons distribution</span>
          </router-link>
        </li>

        <li
          v-if="auth.can('BP_L') || auth.can('BP_Z')"
          class="sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
        >
          <a
            href="#"
            class="accordion-button collapsed rounded-0 shadow-none bg-transparent d-block"
            data-bs-toggle="collapse"
            data-bs-target="#sidebarCollapsePayments"
            aria-expanded="false"
            aria-controls="sidebarCollapsePayments"
          >
            <i class="flaticon-fast-delivery"></i>
            <span class="title">Factures Livreurs</span>
          </a>
          <div
            id="sidebarCollapsePayments"
            class="accordion-collapse collapse"
            data-bs-parent="#sidebarNavAccordion"
          >
            <div class="accordion-body">
              <ul class="sidebar-sub-menu ps-0 mb-0 list-unstyled">
                <li class="sidebar-sub-menu-item" v-if="auth.can('BP_L')">
                  <router-link
                    to="/payment-note-liste"
                    class="sidebar-sub-menu-link"
                  >
                    Factures livreurs
                  </router-link>
                </li>
                <li class="sidebar-sub-menu-item" v-if="auth.can('BP_Z')">
                  <router-link
                    to="/payment-zone-liste"
                    class="sidebar-sub-menu-link"
                  >
                    Factures Zones
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
        </li>

        <li
          v-if="auth.can('BR_Z') || auth.can('BR_C')"
          class="sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
        >
          <a
            href="#"
            class="accordion-button collapsed rounded-0 shadow-none bg-transparent d-block"
            data-bs-toggle="collapse"
            data-bs-target="#sidebarCollapseReturn"
            aria-expanded="false"
            aria-controls="sidebarCollapseReturn"
          >
            <i class="flaticon-project"></i>
            <span class="title">Bons de retour</span>
          </a>
          <div
            id="sidebarCollapseReturn"
            class="accordion-collapse collapse"
            data-bs-parent="#sidebarNavAccordion"
          >
            <div class="accordion-body">
              <ul class="sidebar-sub-menu ps-0 mb-0 list-unstyled">
                <li class="sidebar-sub-menu-item" v-if="auth.can('BR_Z')">
                  <router-link
                    to="/return-zone-liste"
                    class="sidebar-sub-menu-link"
                  >
                    Retours zones
                  </router-link>
                </li>
                <li class="sidebar-sub-menu-item" v-if="auth.can('BR_C')">
                  <router-link
                    to="/return-client-liste"
                    class="sidebar-sub-menu-link"
                  >
                    Retours clients
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
        </li>

        <li
          v-if="auth.can('INV')"
          class="sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
        >
          <a
            href="#"
            class="accordion-button collapsed rounded-0 shadow-none bg-transparent d-block"
            data-bs-toggle="collapse"
            data-bs-target="#sidebarCollapseinvoices"
            aria-expanded="false"
            aria-controls="sidebarCollapseinvoices"
          >
            <i class="flaticon-money"></i>
            <span class="title">Factures Client</span>
          </a>
          <div
            id="sidebarCollapseinvoices"
            class="accordion-collapse collapse"
            data-bs-parent="#sidebarNavAccordion"
          >
            <div class="accordion-body">
              <ul class="sidebar-sub-menu ps-0 mb-0 list-unstyled">
                <li class="sidebar-sub-menu-item">
                  <router-link
                    to="/invoices-liste"
                    class="sidebar-sub-menu-link"
                  >
                    Liste des factures
                  </router-link>
                </li>
                <li class="sidebar-sub-menu-item">
                  <router-link to="/add-invoices" class="sidebar-sub-menu-link">
                    Nouvelle Facture
                  </router-link>
                </li>

                <li class="sidebar-sub-menu-item" v-if="auth.can('VIREMENT')">
                  <router-link
                    to="/virements-liste"
                    class="sidebar-sub-menu-link"
                  >
                    Virements
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
        </li>

        <li
          v-if="auth.can('CUSTOMERS') || auth.can('NEW_CUSTOMERS')"
          class="sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
        >
          <a
            href="#"
            class="accordion-button collapsed rounded-0 shadow-none bg-transparent d-block"
            data-bs-toggle="collapse"
            data-bs-target="#sidebarCollapseCusts"
            aria-expanded="false"
            aria-controls="sidebarCollapseCusts"
          >
            <i class="flaticon-users-group"></i>
            <span class="title">Clients</span>
          </a>
          <div
            id="sidebarCollapseCusts"
            class="accordion-collapse collapse"
            data-bs-parent="#sidebarNavAccordion"
          >
            <div class="accordion-body">
              <ul class="sidebar-sub-menu ps-0 mb-0 list-unstyled">
                <li class="sidebar-sub-menu-item" v-if="auth.can('CUSTOMERS')">
                  <router-link
                    to="/customers-list"
                    class="sidebar-sub-menu-link"
                  >
                    Liste des clients
                  </router-link>
                </li>
                <li
                  class="sidebar-sub-menu-item"
                  v-if="auth.can('NEW_CUSTOMERS')"
                >
                  <router-link
                    to="/new-customers-list"
                    class="sidebar-sub-menu-link"
                  >
                    Nouveaux Clients
                  </router-link>
                </li>
                <!-- <li
                  class="sidebar-sub-menu-item"
                  v-if="auth.can('REQUEST_RIB')"
                >
                  <router-link
                    to="/rib-requests-list"
                    class="sidebar-sub-menu-link"
                  >
                    Demandes RIB
                  </router-link>
                </li>
                <li
                  class="sidebar-sub-menu-item"
                  v-if="auth.can('REQUEST_PHONE')"
                >
                  <router-link
                    to="/phone-requests-list"
                    class="sidebar-sub-menu-link"
                  >
                    Demandes Téléphone
                  </router-link>
                </li> -->

                <li
                  class="sidebar-sub-menu-item"
                  v-if="auth.can('CUSTOMERS')"
                >
                  <router-link
                    to="/verifications"
                    class="sidebar-sub-menu-link"
                  >
                   Centre de vérification
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
        </li>

        <li class="sidebar-nav-item" v-if="auth.can('CLAIM')">
          <router-link to="/claims-list" class="sidebar-nav-link d-block">
            <i class="flaticon-warning"></i>
            <span class="title">Réclamations</span>
          </router-link>
        </li>

        <li
          v-if="auth.can('PICK_UP')"
          class="sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
        >
          <a
            href="#"
            class="accordion-button collapsed rounded-0 shadow-none bg-transparent d-block"
            data-bs-toggle="collapse"
            data-bs-target="#sidebarCollapsePickup"
            aria-expanded="false"
            aria-controls="sidebarCollapsePickup"
          >
            <i class="flaticon-layer-2"></i>
            <span class="title">Ramassage</span>
          </a>
          <div
            id="sidebarCollapsePickup"
            class="accordion-collapse collapse"
            data-bs-parent="#sidebarNavAccordion"
          >
            <div class="accordion-body">
              <ul class="sidebar-sub-menu ps-0 mb-0 list-unstyled">
                <li class="sidebar-sub-menu-item">
                  <router-link to="/pickup-list" class="sidebar-sub-menu-link">
                    Bon de ramassage
                  </router-link>
                </li>
                <li class="sidebar-sub-menu-item">
                  <router-link
                    to="/requests-pickup-list"
                    class="sidebar-sub-menu-link"
                  >
                    Demandes de ramassages
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
        </li>

        <li
          v-if="auth.can('USERS') || auth.can('NEW_LIVREUR')"
          class="sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
        >
          <a
            href="#"
            class="accordion-button collapsed rounded-0 shadow-none bg-transparent d-block"
            data-bs-toggle="collapse"
            data-bs-target="#sidebarCollapseEleven"
            aria-expanded="false"
            aria-controls="sidebarCollapseEleven"
          >
            <i class="flaticon-user-3"></i>
            <span class="title">Utilisateurs</span>
          </a>
          <div
            id="sidebarCollapseEleven"
            class="accordion-collapse collapse"
            data-bs-parent="#sidebarNavAccordion"
          >
            <div class="accordion-body">
              <ul class="sidebar-sub-menu ps-0 mb-0 list-unstyled">
                <li class="sidebar-sub-menu-item" v-if="auth.can('USERS')">
                  <router-link to="/users-list" class="sidebar-sub-menu-link">
                    Liste des utilisateurs
                  </router-link>
                </li>
                <li
                  class="sidebar-sub-menu-item"
                  v-if="auth.can('NEW_LIVREUR')"
                >
                  <router-link
                    to="/new-driver-list"
                    class="sidebar-sub-menu-link"
                  >
                    Nouveaux livreurs
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
        </li>

        <li class="sidebar-nav-item" v-if="auth.can('SETTINGS')">
          <router-link to="/spents" class="sidebar-nav-link d-block">
            <i class="flaticon-warning"></i>
            <span class="title">Les dépenses</span>
          </router-link>
        </li>
        

        <li
          class="sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
        >
          <a
            href="#"
            class="accordion-button collapsed rounded-0 shadow-none bg-transparent d-block"
            data-bs-toggle="collapse"
            data-bs-target="#sidebarCollapseTwentyTwo"
            aria-expanded="false"
            aria-controls="sidebarCollapseTwentyTwo"
          >
            <i class="flaticon-setting"></i>
            <span class="title">Paramètres</span>
          </a>
          <div
            id="sidebarCollapseTwentyTwo"
            class="accordion-collapse collapse"
            data-bs-parent="#sidebarNavAccordion"
          >
            <div class="accordion-body">
              <ul class="sidebar-sub-menu ps-0 mb-0 list-unstyled">
                <li class="sidebar-sub-menu-item">
                  <router-link to="/profile" class="sidebar-sub-menu-link">
                    Profile
                  </router-link>
                </li>
                <li class="sidebar-sub-menu-item" v-if="auth.can('SETTINGS')">
                  <router-link
                    to="/account-settings"
                    class="sidebar-sub-menu-link"
                  >
                    Général
                  </router-link>
                </li>
                <li class="sidebar-sub-menu-item" v-if="auth.can('SETTINGS')">
                  <router-link
                    to="/zones-settings"
                    class="sidebar-sub-menu-link"
                  >
                    Zones
                  </router-link>
                </li>

                <li class="sidebar-sub-menu-item" v-if="auth.can('SETTINGS')">
                  <router-link
                    to="/cities-settings"
                    class="sidebar-sub-menu-link"
                  >
                    Villes
                  </router-link>
                </li>
                <li class="sidebar-sub-menu-item" v-if="auth.can('SETTINGS')">
                  <router-link
                    to="/agencies-settings"
                    class="sidebar-sub-menu-link"
                  >
                    Agences
                  </router-link>
                </li>
                <li
                  class="sidebar-sub-menu-item"
                  v-if="auth.can('SETTINGS_ADS')"
                >
                  <router-link to="/ads-settings" class="sidebar-sub-menu-link">
                    Annonces
                  </router-link>
                </li>
                <li
                  class="sidebar-sub-menu-item"
                  v-if="auth.can('BLACK_LISTE')"
                >
                  <router-link to="/black-list" class="sidebar-sub-menu-link">
                    Black Liste
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
        </li>

        <!-- <li class="sidebar-nav-item">
          <router-link to="/logout" class="sidebar-nav-link d-block">
            <i class="flaticon-logout"></i>
            <span class="title">Logout</span>
          </router-link>
        </li> -->
      </ul>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import stateStore from "../../utils/store";
import { useAuthStore } from "@/stores/auth";
import { useSettingsStore } from "@/stores/settings";

export default defineComponent({
  name: "MainSidebar",
  setup() {
    const stateStoreInstance = stateStore;
    const auth = useAuthStore();
    const settingsStore = useSettingsStore();
    return {
      stateStoreInstance,
      auth,
      settingsStore,
    };
  },
});
</script>